import { Button } from '@mui/material';
import useCourse from '../Hooks/useCourse';
import SchoolIcon from '@mui/icons-material/School';
import { Link } from 'react-router-dom';
import { txt } from '../../../services/translation';

export default function FreeButton(){

    const course = useCourse();

    return course?.enrollment?.amount === 0 &&
    
        <Link to="/courses">

            <Button 
                size='small'
                sx={{ml: 1, mt: 1}}
                startIcon={<SchoolIcon />}
            >
                {txt('viewAllCoursesButton')}
            </Button>


        </Link>

}